export default "__VITE_ASSET__BuYdm9dI__"